export const name = 'viewerManagerModesApi' as const
